import WindowsReplacementGeneralInformation from './WindowsReplacementInstallationInformation';

export default WindowsReplacementGeneralInformation;